/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M17 2.2c0-.66-.54-1.2-1.2-1.2H7.4L1 7.4v8.4c0 .66.54 1.2 1.2 1.2h13.6c.66 0 1.2-.54 1.2-1.2z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.2 14.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M10.2 10.6s.04-1.02.82-1.35c1-.44 1.58-1.29 1.58-1.94C12.6 6.03 11.53 5 10.2 5a2.35 2.35 0 0 0-2.4 2.3",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M7.4 1 1 7.4h6.4z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
